import instance from "./Request";

export const getVoucherListService = async (page = 1) => {
  const request = await instance();
  let data = await request.post("/admin/coupons", { page }).catch((error) => {
    return {
      error,
    };
  });
  return data;
};

export const createNewVoucherService = async (data) => {
  const request = await instance();
  let response = await request.post("/admin/new-coupon", data).catch((error) => {
    return {
      error,
    };
  });
  return response;
}

export const editVoucherService = async (data) => {
  const request = await instance();
  let response = await request.put("/coupon/edit", data).catch((error) => {
    return {
      error,
    };
  });
  return response;
};

export const enableDisableVoucherService = async (coupon_id) => {
  const request = await instance();
  let response = await request.post("/coupon/activate", {coupon_id}).catch((error) => {
    return {
      error,
    };
  });
  return response;
}

export const deleteVoucherService = async (coupon_id) => {
  const request = await instance();
  let response = await request.post("/coupon/delete", {coupon_id}).catch((error) => {
    return {
      error,
    };
  });
  return response;
}
